import { array, boolean, date, InferType, object, string } from "yup";
import {
  BuildingUnitSchema,
  IPropertyBuildingUnitForm
} from "./building-unit.schema";
import { HGetKeyEnums } from "@rf-helper/generat-enums-from-keys";

export const propertyBuildingFormSchema = object({
  id: string().label("Id del edificio").default(""),
  name: string()
    .label("Nombre del edificio")
    .required("El nombre del edificio es requerido")
    .default(""),
  dateDelivery: string()
    .label("Fecha de entrega")
    .required("La fecha de entrega es requerida")
    .default(""),
  isNew: boolean().label("Indicador de nuevo edificio").required().default(true),
  isDelete: boolean().label("Indicador de eliminación").required().default(false),
  units: array()
    .of(BuildingUnitSchema)
    .when("isCaptured", {
      is: (isCaptured: boolean) => isCaptured,
      then: schema => schema.min(1, "Debe agregar al menos una unidad"),
      otherwise: schema => schema.min(0)
    })
    .default([]),
  unitsQuantity: string()
    .required("Indique la cant. de unidades captadas")
    .label("Cantidad de unidades")
    .default(""),
  isCaptured: boolean().label("Indicador de captura").default(false)
}).label("Etapa de edificio");

type IPropertyBuildingFormBase = InferType<typeof propertyBuildingFormSchema>;
export interface IPropertyBuildingForm extends IPropertyBuildingFormBase {
  units: IPropertyBuildingUnitForm[];
}
export const CPropertyBuildingForm = propertyBuildingFormSchema.getDefault();
export const CPropertyBuildingFormKeys = HGetKeyEnums(CPropertyBuildingForm) as {
  [K in keyof typeof CPropertyBuildingForm]: K;
};
